import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'
import { PERSONA_IA_OPERACIONAL } from '@modules/aawz-intelligence-v2/constants/Personas'
import { formatQueryParams } from '@utils/Format'

class APIPromptSuggestions extends APITemplate {
  /**
   * Sugestões de prompt da superfície.
   *
   * ⚠️ `persona` mudou de significado: agora é o AGENTE (`CRM` /
   * `CONSULTOR_ESTRATEGICO`, o mesmo valor de `context`). O papel do usuário
   * (`profissional` / `gestor` / `lider`), que antes viajava em `persona`, passou para
   * `papel`.
   *
   * @param {Object} opts
   * @param {string=} opts.persona Id da persona/agente.
   * @param {string=} opts.papel   Papel do usuário no escritório.
   */
  async getSuggestions({
    persona = PERSONA_IA_OPERACIONAL,
    papel = 'profissional',
  } = {}) {
    const params = formatQueryParams({ persona, papel })
    const r = await con.get(intelligenceV2.promptSuggestions + params)
    return r || this.buildErrorResponse({ message: 'Erro inesperado' })
  }
}

export const apiPromptSuggestions = new APIPromptSuggestions()
